// extracted by mini-css-extract-plugin
module.exports = {"landingPage":"landingpage_landingPage__HD1hC","wallet":"landingpage_wallet__38G0u","descriptionlanding":"landingpage_descriptionlanding__1d6Fe"};